<template>
  <vs-row vs-type="block" vs-w="12" id="dashBoardMaterialReport" class="py-1">
    <raw-material-consumption-by-branch ref="rawMaterialConsumptionByBranch"
                                        @getExcel="getRawMaterialConsumptionByBranchExcel" :table-options="tableOptions"
                                        :report-data="byBranchData" @clear="byBranchData = null"/>
    <span v-if="!stop" class="text-xsmall text-secondary bold">
      Ürün Bazlı Ciro Raporu
    </span>
    <vs-row vs-type="flex" vs-w="12" id="materialReportFilter" class="my-2" v-if="stop">
      <vs-input v-model="filterString" class="w-full border-radius border-all" placeholder="Ürün Arama"/>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" class="pt-1" vs-justify="space-between" id="rawMaterialConsumptionHead">
      <vs-col vs-type="flex" :vs-w="hideBranch ? 4 : 2" vs-align="center">
        <vs-button class="p-1 weight-600 text-smaller text-primary" icon-pack="feather"
                   color="transparent">
                   Hammadde
        </vs-button>
      </vs-col>
      <vs-col v-if="!hideBranch" vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span class="text-smaller weight-600">
          Şube
        </span>
      </vs-col>
      <vs-col vs-type="flex" :vs-w="hideBranch ? 3 : 2" vs-align="center" vs-justify="center">
        <span class="text-smaller weight-600">
          Kategori
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span class="text-smaller weight-600">
          Stok
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="1" vs-align="center" vs-justify="center">
        <span class="text-smaller weight-600">
          Birim
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="1" vs-align="center" vs-justify="center" class="">
        <vs-button class="p-1 weight-600 text-smaller text-primary" icon-pack="feather"
                   :icon="(tableOptions.sortBy == 'consumptionSum') ? sortingHeadIcon : null" color="transparent"
                   >Miktar
        </vs-button>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center" class="">
        <vs-button class="p-1 weight-600 text-smaller text-primary" icon-pack="feather"
                   :icon="(tableOptions.sortBy == 'consumptionSumAmount') ? sortingHeadIcon : null" color="transparent"
                   >Maaliyet ₺
        </vs-button>
      </vs-col>
    </vs-row>
    <vs-divider class="my-1"></vs-divider>
    <vs-row vs-type="flex" vs-w="12" class="py-1" vs-justify="space-between"
            v-for="(consumption,index) in (filteredList && filteredList.length > 0 ? filteredList : [])" :key="index">
      <div class="d-flex w-full justify-between cursor-pointer border-bottom border-secondary py-1"
           @click="openByBranchReport(consumption.rawMaterial.id)">
        <vs-col vs-type="flex" :vs-w="hideBranch ? 4 : 2" vs-align="center">
          <span class="text-primary mr-2 text-xsmall weight-600">
            {{ (index + 1) + '.' }}
          </span>
          <span class="text-primary text-xsmall weight-600">
            {{ consumption.rawMaterial.name }}
          </span>
        </vs-col>
        <vs-col v-if="!hideBranch" vs-type="flex" vs-w="2" vs-align="center">
          <span class="text-secondary weight-600 text-xsmall w-full text-center">
            {{ consumption.branch ? consumption.branch.name : 'Tümü' }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" :vs-w="hideBranch ? 3 : 2" vs-align="center">
          <span class="text-secondary weight-600 text-xsmall w-full text-center">
            {{ consumption.rawMaterial.categoryName }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center">
          <span class="text-secondary weight-600 text-xsmall w-full text-center">
            {{ consumption.rawMaterial.stockCode }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="1" vs-align="center">
          <span class="text-secondary weight-600 text-xsmall w-full text-center">
            {{ consumption.rawMaterial.unitName }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="1" vs-align="center">
        <span class="text-primary weight-600 text-xsmall w-full text-center">
            {{ consumption.consumptionSum.toLocaleString() }}
        </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center">
        <span class="text-primary weight-600 text-xsmall w-full text-center">
            {{ $toCurrency(consumption.consumptionSumAmount) }}
        </span>
        </vs-col>
      </div>
    </vs-row>
    <vs-row v-if="!stop" vs-type="flex" vs-w="12" class="pt-3 pb-1" vs-justify="center" vs-align="center">
      <span @click="openDetailPage" class="text-secondary text-xsmaller bold underline cursor-pointer">
        Detay Sayfasına Git
      </span>
    </vs-row>
  </vs-row>
</template>

<script>
import RawMaterialConsumptionByBranch from "./RawMaterialConsumptionByBranch"
import {filterBranchNameList} from "@/api/Filter"
import {GetRawMaterialConsumptionByBranch,GetRawMaterialConsumptionByBranchForDealer, GetRawMaterialConsumptionByBranchExcel,GetRawMaterialConsumptionByBranchExcelForDealer} from "@/api/Reports"

export default {
  props: {
    reportData: {
      type: Array,
      required: true
    },
    stop: {
      type: Boolean,
      required: true
    },
    tableOptions: {
      type: Object,
      required: true
    },
    sortingHeadIcon: {
      type: String,
      required: false
    },
    hideBranch: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RawMaterialConsumptionByBranch
  },
  data() {
    return {
      filterString: null,
      byBranchData: null,
      branches: []
    }
  },
  mounted: async function() {
    this.branches = await filterBranchNameList();
  },
  methods: {
    getRawMaterialConsumptionByBranchExcel(rawMaterialId) {
      if (this.$isRegionalCenterBranch()) {
        GetRawMaterialConsumptionByBranchExcelForDealer(this.tableOptions, rawMaterialId).then(res => {
        if (res && res.status == 200) {
          res.data.branchConsumptions.forEach(x=> {
            x.branch.name = this.branches.find(y=> y.id == x.branch.id).name;
          });
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Hammadde Şube Tüketim Raporu' + now.getDate() + " " + this.$months()[now.getMonth()]
            .name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
      } else {
        GetRawMaterialConsumptionByBranchExcel(this.tableOptions, rawMaterialId).then(res => {
        if (res && res.status == 200) {
          res.data.branchConsumptions.forEach(x=> {
            x.branch.name = this.branches.find(y=> y.id == x.branch.id).name;
          });
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Hammadde Şube Tüketim Raporu' + now.getDate() + " " + this.$months()[now.getMonth()]
            .name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
      }
      
    },
    onSetSortingOptions(prop) {
      this.$emit("onSetSortingOptions", prop)
    },
    openByBranchReport(rawMaterialId) {
      if (this.$isRegionalCenterBranch()) {
        GetRawMaterialConsumptionByBranchForDealer(this.tableOptions, rawMaterialId).then(res => {
        if (res && res.status == 200) {
          res.data.branchConsumptions.forEach(x=> {
            x.branch.name = this.branches.find(y=> y.id == x.branch.id).name;
          });
          this.byBranchData = res.data;
          this.$refs.rawMaterialConsumptionByBranch.isActive = true;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Rapor Hazırlanamadı"
          });
        }
      }).catch((e) => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası"
        });
      });
      } else {
        GetRawMaterialConsumptionByBranch(this.tableOptions, rawMaterialId).then(res => {
        if (res && res.status == 200) {
          res.data.branchConsumptions.forEach(x=> {
            x.branch.name = this.branches.find(y=> y.id == x.branch.id).name;
          });
          this.byBranchData = res.data;
          this.$refs.rawMaterialConsumptionByBranch.isActive = true;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Rapor Hazırlanamadı"
          });
        }
      }).catch((e) => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası"
        });
      });
      }
      
    }
  },
  computed: {
    filteredList() {
      if (!this.filterString) return this.reportData
      return this.reportData.filter(x => x.rawMaterial.name.toLowerCase().includes(this.filterString.toLowerCase()))
    }
  },
}

</script>
